var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container mt-85"},[_c('div',{staticClass:"wrapper-merci center-align col l12"},[_c('h4',{staticClass:"center-align"},[_c('span',{staticClass:"fw-400 fs-12 center-align",domProps:{"innerHTML":_vm._s(_vm.textErreur[_vm.messageKey])}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }